import React from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { Box, Typography } from "@material-ui/core";
import { CommissionTableNestedHeaderData } from "../CommissionTable/CommissionTableHeaderData";

import useStyles from "./styles";

import { ArrowsLeftIcon } from "../../../../assets/icons";

export default function AgentCommissionExpandedContent({ data = {} }) {
  const styles = useStyles();
  const { isDarkMode } = useSelector((state) => state.theme);

  return (
    <>
      {data.invoices.map((invoice) => (
        <Box
          alignItems={"center"}
          display={"flex"}
          gridGap={190}
          className={styles.root}
        >
          <Box display={"flex"} gridGap={16}>
            <ArrowsLeftIcon fill={"#475467"} />
            <Typography className={styles.fieldValue}>
              {invoice.agentAchievementCommissionInvoiceId}
            </Typography>
          </Box>
          <Box gridGap={62} display={"flex"}>
            {CommissionTableNestedHeaderData(isDarkMode).map((item) => (
              <Box
                display={"flex"}
                flexDirection={"column"}
                key={item.id}
                className={styles.field}
              >
                <Typography className={styles.fieldTitle}>
                  {item.headerName}
                </Typography>
                {item.renderCell ? (
                  item.renderCell(invoice)
                ) : (
                  <Typography
                    className={clsx(styles.fieldValue, {
                      [styles.deductionStyle]: invoice[item.field] < 0,
                    })}
                  >
                    {invoice[item.field]}
                  </Typography>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </>
  );
}
